import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectionItem } from './ConnectionItem';
import { useConnectionDispatch } from './ConnectionDispatchProvider';
import { UserConnection } from '../model/UserConnection';
import {
  useAcceptConnectionRequest,
  useRejectConnectionRequest,
} from '../hook/useConnectionAction';

type RequestConnectionItemProps = {
  connection: UserConnection;
};

export const IncomingConnectionItem = ({
  connection,
}: RequestConnectionItemProps) => {
  const connectionDispatch = useConnectionDispatch();
  const rejectRequest = useRejectConnectionRequest(
    connectionDispatch,
    connection,
  );
  const acceptRequest = useAcceptConnectionRequest(
    connectionDispatch,
    connection,
  );
  const actionElement = (
    <>
      <Button
        onClick={acceptRequest}
        disableElevation
        variant='contained'
        sx={{ px: 5, py: 1.5, borderRadius: 7.5 }}
      >
        <Typography>
          <FormattedMessage id='common.confirm' />
        </Typography>
      </Button>
      <Button
        onClick={rejectRequest}
        disableElevation
        variant='outlined'
        sx={{ px: 8, py: 1.5, borderRadius: 7.5, ml: 5 }}
      >
        <Typography>
          <FormattedMessage id='common.ignore' />
        </Typography>
      </Button>
    </>
  );
  return (
    <ConnectionItem actionElement={actionElement} connection={connection} />
  );
};
